// extracted by mini-css-extract-plugin
module.exports = {"w1fjy7al":"w1fjy7al"};